import type { MessageTemplate } from "@repo/app-types/entities/messageTemplate";
import {
  renderMultilineContent,
  renderSingleLineContent,
} from "@repo/ui/content/renderers";
import { IconMail } from "@tabler/icons-react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface MessageTemplateCardProps {
  template: MessageTemplate | undefined;
}

export const MessageTemplateCard: FC<MessageTemplateCardProps> = ({
  template,
}) => {
  return (
    <div
      className={twMerge(
        "flex max-w-72 flex-row items-center space-x-3 overflow-hidden",
        template ? "text-foreground" : "text-muted-foreground",
      )}
    >
      <IconMail className="size-4 shrink-0" />
      {template ? (
        <div className="flex flex-col overflow-hidden">
          <div className="truncate text-sm leading-5">
            {renderSingleLineContent(template.subject)}
          </div>
          <div className="line-clamp-2 text-xs leading-5 text-muted-foreground">
            {renderMultilineContent(template.body)}
          </div>
        </div>
      ) : (
        <div className="text-sm leading-10">Select a message template</div>
      )}
    </div>
  );
};
